module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "fixed_layout",
    class: ['wrapper', _vm.classes]
  }, [_c('header', {
    staticClass: "main-header"
  }, [_vm._m(0), _vm._v(" "), _c('nav', {
    staticClass: "navbar navbar-static-top",
    attrs: {
      "role": "navigation"
    }
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "navbar-custom-menu"
  }, [_c('ul', {
    staticClass: "nav navbar-nav"
  }, [_vm._m(2), _vm._v(" "), _c('li', {
    class: ['dropdown notifications-menu']
  }, [_c('a', {
    staticStyle: {
      "padding-left": "10px"
    },
    on: {
      "click": function($event) {
        $event.preventDefault();
        _vm.openNotifyNews = !_vm.openNotifyNews
      }
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-bell-o"
  }), _vm._v(" "), _c('span', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.unReadAmount > 0),
      expression: "unReadAmount > 0"
    }],
    staticClass: "badge badge-bell"
  }, [_vm._v(_vm._s(_vm.unReadAmount))])])])]), _vm._v(" "), (_vm.getRoleType !== 99 && _vm.getNidinLeague) ? _c('li', [_vm._m(3)]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu"
  }, [_c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "href": "javascript:;",
      "data-toggle": "dropdown"
    }
  }, [_c('img', {
    staticClass: "user-image",
    attrs: {
      "src": "/static/img/default_user-02.png",
      "alt": "User Image"
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "hidden-xs"
  }, [_vm._v(_vm._s(_vm.getAccount))])])]), _vm._v(" "), _c('li', {
    staticClass: "dropdown user user-menu",
    on: {
      "click": _vm.clickLogout
    }
  }, [_vm._m(4)])])])])]), _vm._v(" "), _c('sidebar', {
    attrs: {
      "display-name": _vm.demo.displayName,
      "picture-url": _vm.demo.avatar
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "content-wrapper"
  }, [_c('section', {
    staticClass: "content-header"
  }, [(_vm.openNotifyNews) ? _c('div', {
    staticClass: "notifyNews"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    class: ['col-xs-6 nav-tab text-center right-broder cursor-pointer', {
      'nav-tab-active': !_vm.isRead
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeRead(false)
      }
    }
  }, [_vm._v("未讀")]), _vm._v(" "), _c('div', {
    class: ['col-xs-6 nav-tab text-center cursor-pointer', {
      'nav-tab-active': _vm.isRead
    }],
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.changeRead(true)
      }
    }
  }, [_vm._v("已讀")])]), _vm._v(" "), _c('div', {
    staticClass: "notifyNewsContent"
  }, [(_vm.announcementList.length > 0) ? _c('div', {
    staticClass: "list-group"
  }, [_vm._l((_vm.announcementList), function(news, index) {
    return [_c('a', {
      key: index,
      staticClass: "list-group-item list-group-item-action cursor-pointer",
      on: {
        "click": function($event) {
          $event.preventDefault();
          return _vm.openNews(news)
        }
      }
    }, [_c('div', [_vm._v(_vm._s(news.title))]), _vm._v(" "), _c('small', [_vm._v(_vm._s(news.content))]), _vm._v(" "), _c('div', [_c('small', {
      staticClass: "time"
    }, [_vm._v("系統通知 ｜ " + _vm._s(news.update_time))])])])]
  })], 2) : _c('div', {
    staticClass: "text-center list-group"
  }, [_vm._v("\n            目前沒有" + _vm._s(_vm.isRead ? '已讀' : '未讀') + "公告\n          ")])]), _vm._v(" "), _c('div', {
    staticClass: "footer text-center",
    style: (!_vm.isRead ? 'border-top: 1px solid #f4f4f4;' : 'height:15px')
  }, [_c('a', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.isRead),
      expression: "!isRead"
    }],
    staticClass: "cursor-pointer",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.markAsRead(null)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-check",
    attrs: {
      "aria-hidden": "true"
    }
  }), _vm._v("全部標記為已讀")])])]) : _vm._e(), _vm._v(" "), (_vm.openNotifyNews) ? _c('div', {
    staticClass: "ful-bg",
    on: {
      "click": function($event) {
        _vm.openNotifyNews = false
      }
    }
  }) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "title-block"
  }, [_c('span', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.meta.title))]), _vm._v(" "), (_vm.$route.meta.subTitle) ? _c('span', {
    staticClass: "subTitle"
  }, [_vm._v(" -  " + _vm._s(_vm.$route.meta.subTitle))]) : _vm._e(), _vm._v(" "), (_vm.$route.meta.docLink) ? _c('span', {
    staticClass: "pull-right"
  }, [_c('button', {
    staticClass: "btn btn-primary",
    on: {
      "click": _vm.linkDoc
    }
  }, [_c('i', {
    staticClass: "fa fa-info-circle mr-5"
  }), _vm._v("開啟操作手冊\n          ")])]) : _vm._e()])]), _vm._v(" "), _c('router-view'), _vm._v(" "), _c('nd-announcement-overlay', {
    attrs: {
      "dailog-open": _vm.dailogOpen,
      "message": _vm.message
    },
    on: {
      "update:close": _vm.close
    }
  })], 1), _vm._v(" "), _c('footer', {
    staticClass: "main-footer"
  }, [_c('strong', [_vm._v("Copyright © " + _vm._s(_vm.year) + "\n      "), _c('a', {
    attrs: {
      "href": "javascript:;"
    }
  }, [_vm._v("Nidin")]), _vm._v(".")]), _vm._v(" All rights reserved.\n      "), _c('small', {
    staticClass: "text-current-time data-real-time pull-right"
  }, [_vm._v("資料來源： " + _vm._s(_vm.currentTime))])])], 1)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('span', {
    staticClass: "logo-mini"
  }, [_c('span', {
    staticClass: "img-responsive center-block logo"
  }, [_c('span', {
    staticClass: "sidebar-large"
  }, [_vm._v("Nidin")]), _vm._v(" "), _c('span', {
    staticClass: "sidebar-mini"
  }, [_vm._v("N")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "sidebar-toggle",
    staticStyle: {
      "height": "50px"
    },
    attrs: {
      "href": "javascript:;",
      "data-toggle": "offcanvas",
      "role": "button"
    }
  }, [_c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle navigation")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    staticStyle: {
      "padding-right": "10px"
    },
    attrs: {
      "target": "_blank",
      "href": "https://line.me/ti/p/~@839wddtv"
    }
  }, [_c('div', [_c('i', {
    staticClass: "fa fa-headphones fa-md"
  })])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', [_c('span', {
    staticClass: "nd-tooltip"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/icon/nidin_alliance_logo.svg")
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "nd-tooltip-text alliance-tooltip"
  }, [_vm._v("\n                  你訂聯盟的品牌可享有 ：系統模組9~8折優惠。一~二則你訂首頁Banner一週的曝光。詳情可洽您的商務窗口。\n                ")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('a', {
    staticClass: "dropdown-toggle",
    attrs: {
      "data-toggle": "dropdown"
    }
  }, [_c('span', [_c('i', {
    staticClass: "fa fa-sign-out",
    attrs: {
      "aria-hidden": "true"
    }
  })])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-30fdce3e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Dash.vue
// module id = 2376
// module chunks = 1